import client from "../utils/ApiClient";
import * as url from "./url_helper";

const options = {
  method: "GET",
  url: "",
  headers: {
    "content-type": "application/json",
  },
};

export const getAPIKey = async () => {
  options.method = "GET";
  options.url = url.GET_API_KEY;
  await client
    .request(options)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error;
    });
};

//// LOGIN API

// postForgetPwd
export const postForgetPwd = async (data) => {
  return await client.get(url.POST_PASSWORD_FORGET, { params: data });
};

export const passwordReset = async (data) => {
  return await client.post(url.POST_PASSWORD_RESET, data);
};

// Edit profile
export const postJwtProfile = async (data) => {
  options.method = "POST";
  options.url = url.POST_EDIT_JWT_PROFILE;
  options.data = data;
  await client
    .request(options)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error;
    });
};

// Login Method
export const postLogin = async (data) => {
  options.method = "GET";
  options.url = url.POST_LOGIN;
  options.params = data;
  return await client.get(options.url, { params: data });
};

export const postAdminLogin = async (data) => {
  options.url = url.POST_LOGIN_ADMIN;
  return await client.post(options.url, data);
};

// Login Method
export const postProfile = async (data) => {
  options.method = "POST";
  options.url = url.POST_EDIT_PROFILE;
  options.data = data;
  return await client.post(options.url, data);
};

// Login Method
export const postRegister = async (data) => {
  options.method = "POST";
  options.url = url.POST_REGISTER;
  options.data = data;
  return await client.post(options.url, data);
};

/// Products API

export const getProducts = async (data) => {
  return await client.get(url.GET_PRODUCTS, { params: data });
};
export const getHotProducts = async (data) => {
  return await client.get(url.GET_HOT_PRODUCTS, { params: data });
};
export const getProductById = async (data) => {
  return await client.get(url.GET_PRODUCTS_BY_ID, { params: data });
};
export const addNewProduct = async (data) => {
  return await client.post(url.ADD_NEW_PRODUCT, data);
};
export const updateProduct = async (data) => {
  return await client.put(url.UPDATE_PRODUCT, data);
};

export const deleteProducts = async (data) => {
  return await client.delete(url.DELETE_PRODUCT, data);
};

// Product User Visibility
export const getAssignedUsers = async (data) => {
  return await client.get(url.GET_ASSIGNED_USERS, { params: data });
};

export const assignUsers = async (proId, userIds) => {
  return await client.post(`${url.ASSIGN_USERS}?pro_id=${proId}`, userIds, {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const unassignUser = async (data) => {
  return await client.delete(url.UNASSIGN_USER, { params: data });
};

/// Orders API

export const getOrders = async (data) => {
  return await client.get(url.GET_ORDERS, { params: data });
};

export const changeOrderStatus = async (data) => {
  return await client.post(url.ORDER_CHANGE_STATUS, data);
};

export const getCustomerOrders = async (data) => {
  return await client.get(url.GET_CUSTOMER_ORDERS, { params: data });
};
export const getSupplierOrderById = async (data) => {
  return await client.get(url.GET_ORDERS + "/" + data);
};

export const addNewOrder = async (data) => {
  return await client.post(url.ADD_NEW_ORDER, data);
};
export const updateOrder = async (data) => {
  return await client.put(url.UPDATE_ORDER, data);
};

export const deleteOrder = async (data) => {
  return await client.delete(url.DELETE_ORDER, data);
};
export const purchaseOrder = async (data) => {
  return await client.post(url.PURCHASE_ORDER, data);
};

export const orderShipped = async (data) => {
  return await client.post(url.ORDER_SHIPPED, data);
};

export const cancelSupplierOrder = async (data) => {
  return await client.post(url.CANCEL_SUPLIER_ORDER, data);
};

export const cancelCustomerOrder = async (data) => {
  return await client.post(url.CANCEL_CUSTOMER_ORDER, data);
};

export const offerUnits = async (data) => {
  return await client.post(url.OFFER_UNITS, data);
};
/// Import Files API
export const getFiles = async (data) => {
  return await client.get(url.GET_FILES, data);
};
export const getSuppliers = async (data) => {
  return await client.get(url.SUPPLIERS, { params: data });
};
export const addSupplier = async (data) => {
  return await client.post(url.SUPPLIERS, data);
};
export const updateSupplier = async (data) => {
  return await client.put(url.SUPPLIERS, data);
};
export const deleteSupplier = async (data) => {
  return await client.delete(url.SUPPLIERS, { params: data });
};
export const importFile = async (data) => {
  var response = await client.post(url.IMPORT_FILE, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

export const uploadStockCheckFile = async (data) => {
  return await client.post(url.UPLOAD_STOCKCHECK, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

//ANALYSIS
export const getImports = async (data) => {
  return await client.post(url.GET_IMPORTS, data);
};

export const deleteBatch = async (data) => {
  return await client.delete(
    url.DELETE_BATCH,
    { params: data },
    {
      headers: {
        "content-type": "application/json",
      },
    }
  );
};

export const updateRow = async (data) => {
  return await client.put(url.UPDATE_ROW, data, {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const updateStatus = async (data) => {
  return await client.put(url.UPDATE_STATUS, JSON.stringify(data), {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const getSettings = async (data) => {
  return await client.get(url.GET_SETTINGS, data);
};

export const updateSettings = async (data) => {
  return await client.put(url.UPDATE_SETTINGS, data);
};

//USER
export const getUsers = async (data) => {
  return await client.get(url.USERS, { params: data });
};

export const addUser = async (data) => {
  return await client.post(url.ADD_USER, data, {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const editUser = async (data) => {
  return await client.put(url.EDIT_USER, data, {
    headers: {
      "content-type": "application/json",
    },
  });
};

//GET RESTRICTED BRANDS, MELTABLES, ASINS
export const getRestrictedBrands = async (data) => {
  return await client.get(url.RESTRICTED_BRANDS, { params: data });
};
export const getRestrictedMeltables = async (data) => {
  const response = await client.get(url.RESTRICTED_MELTABLES, { params: data });
  return response;
};
export const getRestrictedAsins = async (data) => {
  return await client.get(url.RESTRICTED_ASINS, { params: data });
};
//ADD
export const addRestrictedBrands = async (data) => {
  return await client.post(url.RESTRICTED_BRANDS, data);
};
export const addRestrictedMeltables = async (data) => {
  return await client.post(url.RESTRICTED_MELTABLES, data);
};
export const addRestrictedAsins = async (data) => {
  return await client.post(url.RESTRICTED_ASINS, data);
};
export const updateRestrictedBrands = async (data) => {
  return await client.put(url.RESTRICTED_BRANDS, data);
};
export const updateRestrictedMeltables = async (data) => {
  return await client.put(url.RESTRICTED_MELTABLES, data);
};
export const updateRestrictedAsins = async (data) => {
  return await client.put(url.RESTRICTED_ASINS, data);
};
//DELETE
export const deleteRestrictedBrands = async (data) => {
  return await client.delete(url.RESTRICTED_BRANDS, { params: data });
};
export const deleteRestrictedMeltables = async (data) => {
  return await client.delete(url.RESTRICTED_MELTABLES, { params: data });
};
export const deleteRestrictedAsins = async (data) => {
  return await client.delete(url.RESTRICTED_ASINS, { params: data });
};

//SUBSCRIPTION FREQUENCIES
export const getSubscriptionFrequencies = async (data) => {
  return await client.get(url.SUBSCRIPTION_FREQUENCIES, { params: data });
};

export const updateSubscriptionFrequencyStatus = async (frequency, data) => {
  return await client.put(`${url.SUBSCRIPTION_FREQUENCIES}/${frequency}`, data);
};

export const getWeeklyUploaded = async (data) => {
  return await client.get(url.GET_WEEKLY_UPLAODED, { params: data });
};
export const getWeeklyUploadedByChannel = async (data) => {
  return await client.get(url.GET_WEEKLY_UPLAODED_BY_CHANNEL, { params: data });
};
export const getWeeklyNewSupliers = async (data) => {
  return await client.get(url.GET_WEEKLY_NEW_SUPPLIERS, { params: data });
};
export const getWeeklyTotalOrderAmount = async (data) => {
  return await client.get(url.GET_WEEKLY_TOTAL_ORDER_AMOUNT, { params: data });
};

// Monthly dashboard endpoints (used when period > 58 days)
export const getMonthlyUploaded = async (data) => {
  return await client.get(url.GET_MONTHLY_UPLOADED, { params: data });
};
export const getMonthlyUploadedByChannel = async (data) => {
  return await client.get(url.GET_MONTHLY_UPLOADED_BY_CHANNEL, { params: data });
};
export const getMonthlyNewSuppliers = async (data) => {
  return await client.get(url.GET_MONTHLY_NEW_SUPPLIERS, { params: data });
};
export const getMonthlyGeneralSupplierOrderCounts = async (data) => {
  return await client.get(url.GET_MONTHLY_GENERAL_SUPPLIER_ORDER_COUNTS, {
    params: data,
  });
};
export const getMonthlyGeneralCustomerOrderCounts = async (data) => {
  return await client.get(url.GET_MONTHLY_GENERAL_CUSTOMER_ORDER_COUNTS, {
    params: data,
  });
};
export const getMonthlyRefunds = async (data) => {
  return await client.get(url.GET_MONTHLY_REFUNDS, { params: data });
};
export const getMonthlyProfitableProducts = async (data) => {
  return await client.get(url.GET_MONTHLY_PROFITABLE_PRODUCTS, { params: data });
};

export const getUserStats = async (data) => {
  return await client.get(url.GET_USER_STATS, { params: data });
};
export const getUserStatsRange = async (data) => {
  return await client.get(url.GET_USER_STATS_RANGE, { params: data });
};
export const getUsersStatsByRange = async (data) => {
  return await client.get(url.GET_USERS_STATS_BY_RANGE, { params: data });
};
export const getWeeklyTotalSupplierCancelledOrders = async (data) => {
  return await client.get(url.GET_TOTAL_SUPPLIER_CANCELLED_ORDERS, {
    params: data,
  });
};
export const getWeeklyTotalCustomerCancelledOrders = async (data) => {
  return await client.get(url.GET_TOTAL_CUSTOMER_CANCELLED_ORDERS, {
    params: data,
  });
};
export const getWeeklyGeneralSupplierOrderCounts = async (data) => {
  return await client.get(url.GET_WEEKLY_GENERAL_SUPPLIER_ORDER_COUNTS, {
    params: data,
  });
};
export const getGeneralSupplierOrderCounts = async (data) => {
  return await client.get(url.GET_GENERAL_SUPPLIER_ORDER_COUNTS, {
    params: data,
  });
};
export const getWeeklyGeneralCustomerOrderCounts = async (data) => {
  return await client.get(url.GET_WEEKLY_GENERAL_CUSTOMER_ORDER_COUNTS, {
    params: data,
  });
};
export const getInventoryHistory = async (data) => {
  return await client.get(url.GET_INVENTORY_HISTORY, { params: data });
};
export const getWeeklyProfitableProducts = async (data) => {
  return await client.get(url.GET_WEEKLY_PROFITABLE_PRODUCTS, { params: data });
};

export const getSubscriptionStats = async (data) => {
  return await client.get(url.GET_SUBSCRIPTION_STATS, { params: data });
};
export const getWeeklyTotalPurchases = async (data) => {
  return await client.get(url.GET_WEEKLY_TOTAL_PURCHASES, { params: data });
};
export const getWeeklyRefunds = async (data) => {
  return await client.get(url.GET_WEEKLY_REFUNDS, { params: data });
};
export const getTopMembersPurchases = async (data) => {
  return await client.get(url.GET_TOP_MEMBERS_PURCHASES, { params: data });
};
export const getTopProductMargins = async (data) => {
  return await client.get(url.GET_TOP_PRODUCT_MARGINS, { params: data });
};
export const getTopSellers = async (data) => {
  return await client.get(url.GET_TOP_SELLERS, { params: data });
};
export const getTopSellerSuppliers = async (data) => {
  return await client.get(url.GET_TOP_SELLER_SUPPLIERS, { params: data });
};

export const getSubscriptions = async (data) => {
  return await client.get(url.GET_SUBSCRIPTIONS, { params: data });
};
